<template>
  <div
    class="has-background-light is-border-top"
    id="lots"
    v-if="programLots">
    <div class="is-padding has-background-white is-border-left is-border-right">
      <div class="title is-5 is-uppercase">
        Lot<span v-if="programLots.length > 0">s</span> du {{ nameToUse }}
      </div>
    </div>
    <tabs
      :level="1"
      :is-fullwidth="true"
      :links="lotListLinks"
      :current-tab="lotListTab"
      @changeView="lotListTab = $event"
      mode="emitter"
      class="has-background-white is-border-left is-border-right is-border-top"></tabs>
    <div class="is-padding-top-xsmall is-padding-bottom-xsmall is-padding-left is-padding-right is-border-top is-border-left is-border-right">
      <div class="columns is-variable is-2 is-vcentered">
        <div
          class="column is-narrow is-size-6 is-flex"
          :for="s.value"
          v-for="s in profilAvailableStatus"
          :key="s.value">
          <span
            class="dot is-small is-self-centered is-margin-right-xxsmall"
            :class="s.value|programStatusClass"></span>
          <span>{{ s.label }}</span>
        </div>
      </div>
    </div>
    <lot-list
      id="lotList"
      @sort="sort"
      @reload="reload"
      :is-loading="loading"
      :no-more-result="getNoMoreResult()"
      :source-lots="getSourceLot()"
      :is-parking="lotListTab === 'Parking'"
      :is-program-view="true"
      :is-other="lotListTab === 'Autre'"></lot-list>
    <pagination
      :loading="loading"
      :current-page="currentPage"
      :total-page="totalPage"
      @changePage="loadData($event)"></pagination>
    <cta-to-promoteur
      v-if="!(isPromoteur && isAdmin)"
      class="is-sticky--bottom is-margin-left-auto is-margin-right is-margin-top"
      @clickOnCta="$emit('openModalTicket');"></cta-to-promoteur>
  </div>
</template>

<script>
import { DefaultValues, Sort } from '@/mixins'
import { mapGetters } from 'vuex'
import CtaToPromoteur from '@/components/utils/CtaToPromoteur'

export default {
  name: 'ProgramLots',
  components: {
    LotList: () => import('@/components/stock/LotList'),
    CtaToPromoteur
  },
  mixins: [DefaultValues, Sort],
  props: {
    lotPages: Number,
    currentLotPage: Number,
    autrePages: Number,
    currentAutrePage: Number,
    parkingPages: Number,
    currentParkingPage: Number,
    loading: Boolean,
    noMoreResult: Boolean,
    noParkingMoreResult: Boolean,
    noAutreMoreResult: Boolean,
    program: {
      required: true
    },
    programLotsCount: {
      required: true
    },
    programParkingsCount: {
      required: true
    },
    programAutresCount: {
      required: true
    },
    programLots: {
      required: true
    },
    programParkings: {
      required: true
    },
    programAutres: {
      required: true
    }
  },
  data () {
    return {
      loadDocuments: this.getProgramLots,
      sortBy: {},
      filters: {},
      lotListTab: 'Logement',
      totalPage: null,
      currentPage: null
    }
  },
  computed: {
    ...mapGetters(['isPromoteur', 'isAdmin']),
    lotListLinks () {
      return [
        { link: 'Logement', label: `${this.programLotsCount} logement(s)` },
        { link: 'Parking', label: `${this.programParkingsCount} stationnement(s)` },
        { link: 'Autre', label: `${this.programAutresCount} autre(s)` }
      ]
    },
    nameToUse () {
      if (this.program && this.program.is_amenagement) {
        return 'lotissement'
      } else {
        return 'programme'
      }
    }
    // filteredLogements () {
    //   if (this.programLots && this.programLots.length) {
    //     return this.programLots.filter(x => x.nature !== 'parking')
    //   }
    //   return []
    // },
    // filteredParkings () {
    //   if (this.programLots && this.programLots.length) {
    //     return this.programLots.filter(x => x.nature === 'parking')
    //   }
    //   return []
    // }
  },
  created () {
    this.initPagination()
  },
  updated () {
    this.initPagination()
  },
  methods: {
    loadData ($event) {
      if (this.lotListTab === 'Logement') {
        this.getProgramLots($event)
      } else if (this.lotListTab === 'Parking') {
        this.getProgramParkings($event)
      } else if (this.lotListTab === 'Autre') {
        this.getProgramAutres($event)
      }
    },
    initPagination () {
      if (this.lotListTab === 'Logement') {
        this.totalPage = this.lotPages
        this.currentPage = this.currentLotPage
      } else if (this.lotListTab === 'Parking') {
        this.totalPage = this.parkingPages
        this.currentPage = this.currentParkingPage
      } else if (this.lotListTab === 'Autre') {
        this.totalPage = this.autrePages
        this.currentPage = this.currentAutrePage
      }
    },
    reload () {
      if (this.lotListTab === 'Logement') {
        this.$emit('getProgramLots')
      } else if (this.lotListTab === 'Parking') {
        this.$emit('getProgramParkings')
      } else {
        this.$emit('getProgramAutres')
      }
    },
    getProgramLots (page = 1) {
      this.$emit('getProgramLots', this.filters, page)
    },
    getProgramParkings (page = 1) {
      this.$emit('getProgramParkings', this.filters, page)
    },
    getProgramAutres (page = 1) {
      this.$emit('getProgramAutres', this.filters, page)
    },
    getSourceLot () {
      switch (this.lotListTab) {
        case 'Parking':
          return this.programParkings
        case 'Autre':
          return this.programAutres
        default:
          return this.programLots
      }
    },
    getNoMoreResult () {
      switch (this.lotListTab) {
        case 'Parking':
          return this.noParkingMoreResult
        case 'Autre':
          return this.noAutreMoreResult
        default:
          return this.noMoreResult
      }
    }
  }
}
</script>
